import { getSelectorFromElement } from '../get-selector-from-element';

export function getSelectorElementFromElement(
	element: Element,
	attribute = 'data-target',
	fallbackHref = true
): HTMLElement | null {
	const selector = getSelectorFromElement(element, attribute, fallbackHref);

	if (selector && selector.indexOf('#') === 0) {
		return document.getElementById(selector.substr(1, selector.length - 1));
	}

	return null;
}
